module.exports = __webpack_public_path__ + "downloads/Location.36c61e09.xlsx";